import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import Image from 'components/atoms/Image';
import { bindActionCreators, Dispatch } from 'redux';
import { userGetToken, userKillToken } from 'services/users';
import {
    SetErrorHandlerAction,
    setErrorHandlerAction,
    SetSystemLoadingAction,
    setSystemLoadingAction,
} from 'store/actions/errorsActions';
import { PortType, RootState } from 'types';
import { ActionsType } from 'types/system';
import { formatServerErrors } from 'utils/formatServerErrors';
import { translate } from 'utils/translate';

interface GetTokenModelProps {
    children?: string | JSX.Element | JSX.Element[];
    language: string;
    id?: string;
    data: any;
    actions: ActionsType | undefined;
    port: PortType;
    setErrorHandlerAction: SetErrorHandlerAction;
    setSystemLoadingAction: SetSystemLoadingAction;
}

interface GetTokenModelState {
    errors: object;
    data: any | null;
    loading: boolean;

    overwite: boolean;
    token: string;
}

class GetTokenModel extends Component<GetTokenModelProps, GetTokenModelState> {
    constructor(props: GetTokenModelProps) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            loading: false,
            overwite: false,
            token: '',
        };
    }

    componentDidMount(): void {
        console.log(this.props.data);
        this.getToken();
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.setState({ errors: {}, loading: true }, () => {
            userKillToken(this.props.port.id, this.props.data.id)
                .then(() => {
                    this.props.actions?.onConfirm();
                    this.props.actions?.onCancel();
                })
                .catch((errors) => {
                    switch (errors.response?.status) {
                        case 422:
                            this.setState({ errors: formatServerErrors(errors), loading: false });
                            break;
                        default:
                            this.setState({ loading: false });
                            this.props.setErrorHandlerAction(errors);
                            break;
                    }

                    return;
                });
        });
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };
    getToken = () => {
        this.setState({ loading: true }, () => {
            userGetToken(this.props.port.id, this.props.data.id)
                .then((res) => {
                    //update state and save the data
                    this.setState({
                        loading: false,
                        token: res.items.token,
                    });
                    console.log(res);
                    this.props.setSystemLoadingAction(false);
                })
                .catch((error) => {
                    this.props.setErrorHandlerAction(error);
                });
        });
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Get user token')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>

                    <div className="mt-2 cursor-pointer text-gray-500">
                        {translate('please take care while using this token to login to the system')}
                    </div>

                    {this.state.loading ? (
                        <div className="flex items-center justify-center ">
                            <div className="flex justify-start items-center gap-1 max-w-3xl mx-auto text-center  leading-9   text-gray-900">
                                <Image src="/static/images/loading.svg" className="mx-auto w-4" alt="error" />
                                <p>{translate('Loading, Please Wait...')}</p>
                            </div>
                        </div>
                    ) : (
                        <div className="mt-6 font-bold">{this.state.token}</div>
                    )}

                    <div className="flex justify-end">
                        <div className="mt-5 flex gap-3">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('close')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const GetTokenModelStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    port: state.port.port,
});

const GetTokenModelDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
    setSystemLoadingAction: bindActionCreators(setSystemLoadingAction, dispatch),
});

export default connect(GetTokenModelStateToProps, GetTokenModelDispatchToProps)(GetTokenModel);
